module.exports = __webpack_public_path__ + "media/images/official/top_about2-d3aecaa73beb63c19e05f88bff687dc4.webp";